import Status from 'clarks/components/ivu-table/status'

let forms = {
   edit_schema: {
      icon: 'fa fa-university',
      title: 'Edit Schema',
      subtitle: 'Update Schema Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12", validation: "required|min:3|max:100", model: "alias", label: "Alias", },
         { type: 'textarea', class: 'col-12', model: 'description', rows: '3', validation: 'min:10|max:500', label: 'Description'},
      ]
   },
}

let tables = {
   schema: {
      props: {
         icon: 'fa fa-database',
         title: 'Schemata',
         border: true,
         'max-height': 700,
         'show-summary': false,
         search_fields: ['name', 'db_name', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Name", min_width: 300, key: "name", },
            { title: "Alias", key: "alias", },
            { title: "Database", min_width: 200, key: "db_name", },
            { title: "Date Created", slot: "date", align: 'center', width: 150, sortable: true, },
            { title: "Time Created", slot: "time", align: 'center', width: 150 },
            {
               title: "Status",
               key: "status",
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [{
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch (value) {
                     case 1:
                        return row.status === 'created';
                     case 2:
                        return row.status === 'updated';
                     case 3:
                        return row.status === 'create_pending';
                     case 4:
                        return row.status === 'update_pending';
                     case 5:
                        return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'Edit', event: 'schema:edit', icon: 'fa-edit', allow_multiple: false },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}